import { initDeleteMilestoneModal, initPromoteMilestoneModal } from '~/milestones';

initDeleteMilestoneModal();
initPromoteMilestoneModal();
